import * as React from 'react';
import Page from './page'

const NotFound = () => {
  return <Page>Page Not Found!</Page>;
}

export default NotFound;
